import { render, staticRenderFns } from "./attach-vehicle.vue?vue&type=template&id=6a9106ae&scoped=true"
var script = {}
import style0 from "./attach-vehicle.vue?vue&type=style&index=0&id=6a9106ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9106ae",
  null
  
)

export default component.exports